"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retrieveInitialDocumentResourceTiming = retrieveInitialDocumentResourceTiming;
var browser_core_1 = require("@datadog/browser-core");
var performanceObservable_1 = require("../../browser/performanceObservable");
var getDocumentTraceId_1 = require("../tracing/getDocumentTraceId");
var performanceUtils_1 = require("../../browser/performanceUtils");
var resourceUtils_1 = require("./resourceUtils");
function retrieveInitialDocumentResourceTiming(configuration, callback) {
    (0, browser_core_1.runOnReadyState)(configuration, 'interactive', function () {
        var entry = (0, browser_core_1.assign)((0, performanceUtils_1.getNavigationEntry)().toJSON(), {
            entryType: performanceObservable_1.RumPerformanceEntryType.RESOURCE,
            initiatorType: resourceUtils_1.FAKE_INITIAL_DOCUMENT,
            traceId: (0, getDocumentTraceId_1.getDocumentTraceId)(document),
            toJSON: function () { return (0, browser_core_1.assign)({}, entry, { toJSON: undefined }); },
        });
        callback(entry);
    });
}
//# sourceMappingURL=retrieveInitialDocumentResourceTiming.js.map